var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { useEffect, useState } from 'react';
import { Icon } from "../UI";
import { store } from "../store";
import { SidePanel } from "../Layout";
import { Translate } from "../I18N";



import SourceDocument from "../Viewer/components/SourceDocument";
import { DocumentForm } from "../Viewer/containers/DocumentForm";
import { clearMetadataSelections, loadFetchedInReduxForm } from "../Metadata/actions/actions";
import { actions } from "../BasicReducer";
import { unsetSelection } from "../Viewer/actions/selectionActions";
import { fetchEntity, fetchFile, scrollToPage } from "./actions/actions";








const PDFSidePanel = ({
  open,
  entitySuggestion,
  closeSidePanel,
  handleSave
}) => {
  const [entity, setEntity] = useState({});
  const [file, setFile] = useState({});
  const templates = store === null || store === void 0 ? void 0 : store.getState().templates;

  useEffect(() => {
    fetchEntity(entitySuggestion.entityId, entitySuggestion.language).
    then((response) => {
      setEntity(response[0]);
      loadFetchedInReduxForm(
        'documentViewer.sidepanel.metadata',
        response[0],
        templates === null || templates === void 0 ? void 0 : templates.toJS()
      ).forEach((action) => store === null || store === void 0 ? void 0 : store.dispatch(action));
    }).
    catch((e) => e);
  }, [entitySuggestion]);

  useEffect(() => {
    if (entitySuggestion.fileId) {
      fetchFile(entitySuggestion.fileId).
      then((response) => {
        const responseFile = response.json[0];
        setFile(responseFile);

        // Load selections to the store
        const defaultDoc = _objectSpread(_objectSpread({},
        responseFile), {}, {
          extractedMetadata: responseFile.extractedMetadata ?
          responseFile.extractedMetadata.filter(
            (metadata) => metadata.name === entitySuggestion.propertyName
          ) :
          [] });


        store === null || store === void 0 ? void 0 : store.dispatch(actions.update('viewer/doc', _objectSpread(_objectSpread({}, entity), {}, { defaultDoc })));
      }).
      catch((e) => e);

      return () => {
        store === null || store === void 0 ? void 0 : store.dispatch(unsetSelection());
        store === null || store === void 0 ? void 0 : store.dispatch(actions.update('viewer/doc', entity));
        store === null || store === void 0 ? void 0 : store.dispatch(clearMetadataSelections());
      };
    }
  }, [entitySuggestion]);

  return open ? /*#__PURE__*/
  _jsx(SidePanel, { className: "wide", open: open }, void 0, /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("div", { className: "sidepanel-header buttons-align-right" }, void 0, /*#__PURE__*/
  _jsx("button", {
    type: "button",
    className: "closeSidepanel close-modal",
    onClick: closeSidePanel,
    "aria-label": "Close side panel" }, void 0, /*#__PURE__*/

  _jsx(Icon, { icon: "times" })
  ), /*#__PURE__*/
  _jsx("div", { className: "button-list" }, void 0, /*#__PURE__*/
  _jsx("button", { type: "button", className: "btn btn-default", onClick: closeSidePanel }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Cancel")
  ), /*#__PURE__*/
  _jsx("button", { type: "submit", className: "btn btn-success", form: "metadataForm" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Save")
  )
  )
  ),
  entity.sharedId && file.filename && /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx(DocumentForm, {
    sharedId: entity.sharedId,
    showSubset: [entitySuggestion.propertyName],
    storeKey: "documentViewer",
    fileID: entitySuggestion.fileId,
    onEntitySave: handleSave }
  ), /*#__PURE__*/
  _jsx("div", { className: "document-viewer" }, void 0, /*#__PURE__*/
  _jsx(SourceDocument, {
    file: file,
    onPageLoaded: async () => {
      await scrollToPage(entitySuggestion.page || 1);
    } }
  )
  )
  )

  )
  ) : /*#__PURE__*/

  // eslint-disable-next-line react/jsx-no-useless-fragment
  React.createElement(React.Fragment, null);

};

export { PDFSidePanel };